import React from 'react';
import PropTypes from 'prop-types';
import {
  googleMapsInit,
  mapOptions,
  markerImage,
  markerStyle,
  popupStyle,
  enableZoomControls,
} from '../../../utils/google-maps';
import { logError } from '../../../utils/logging';
import { getStoreTradingHours } from '../../../utils/store/storeTradingHoursUtils';
import { STORE_LOCATIONS_COORDS, STORE_LOCATIONS } from '../../../utils/location/locationHelper';

let map;
let infoWindow;
let markerClusters;
let bounds;

function removeWhitespaceAndCommas(str) {
  return str.replace(/(^\s*,)|(,\s*$)|(^\s+)|(\s+$)/g, '');
}

export function formatAddress(address) {
  const { Line1 = '', Line2 = '', Line3 = '', Suburb = '' } = address;

  const formattedAddress = `${Line1 ? `${removeWhitespaceAndCommas(Line1)}` : ''}${
    Line2 ? `<br/>${removeWhitespaceAndCommas(Line2)}` : ''
  }${Line3 ? `<br/>${removeWhitespaceAndCommas(Line3)}` : ''},${
    Suburb ? `<br/>${removeWhitespaceAndCommas(Suburb)}` : ''
  }`;

  return formattedAddress;
}

const openPopup = marker => {
  if (infoWindow) {
    infoWindow.close();
  }

  // Popup content
  const markup = `<div>
    <h3>${marker.title}</h3>
    <p>${marker.address}, ${marker.state ? marker.state + ', ' : ''} ${marker.postcode}</p>
    <p>Phone: ${marker.phone}</p>
    <h4>Opening Hours</h4>
    <p>Today: ${marker.today}</p>
    <p>Tomorrow: ${marker.tomorrow}</p>
    <a href="/pages/${marker.url}" title="${marker.title} store information" class="button secondary">More Info</a>
  </div>`;

  const popup = popupStyle({
    content: markup,
    backgroundClassName: 'marker-popup-store',
  });

  infoWindow = new InfoBubble(popup);
  infoWindow.open(map, marker);
};

const removeMarkers = () => {
  if (markerClusters) {
    markerClusters.clearMarkers();
  }
};

const renderMarkers = locations => {
  removeMarkers();

  // If there was an info window open, close it
  if (infoWindow) {
    infoWindow.close();
  }

  bounds = new google.maps.LatLngBounds();

  const markers = locations.map(location => {
    const geoData = {
      lat: location._geoloc.lat,
      lng: location._geoloc.lng,
    };

    const formattedAddress = formatAddress(location.storeAddress);
    const marker = new google.maps.Marker(
      markerStyle(
        {
          position: geoData,
          title: location.storeName,
          today: getStoreTradingHours(location.scheduledTradingHoursForTheComingWeek, 'today'),
          tomorrow: getStoreTradingHours(location.scheduledTradingHoursForTheComingWeek, 'tomorrow'),
          phone: location.phone,
          address: formattedAddress,
          state: location.storeAddress.State || '',
          postcode: location.storeAddress.Postcode,
          url: location.url,
        },
        'single'
      )
    );
    google.maps.event.addListener(marker, 'click', () => openPopup(marker));
    bounds.extend(marker.position);
    return marker;
  });

  markerClusters = new MarkerClusterer(map, markers, {
    gridSize: 50,
    maxZoom: 15,
    styles: [
      {
        url: markerImage('cluster'),
        height: 69,
        width: 47,
        anchor: [10, 0],
        textColor: '#000',
        enableEventPropagation: true,
        textSize: 12,
      },
    ],
  });

  map.fitBounds(bounds);
  try {
    const zoom = map.getZoom();
    map.setZoom(zoom > 16 ? 16 : zoom);
  } catch (error) {
    logError(error, 'Error in zooming map');
  }
};

class storeMap extends React.Component {
  constructor() {
    super();
    this.state = {
      googleLoaded: false,
    };
    this.loadMap = this.loadMap.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.state.googleLoaded) {
      if (this.props.locations !== prevProps.locations && this.props.locations.length) {
        renderMarkers(this.props.locations);
      }
    }
  }

  loadMap() {
    // Center of Australia & New Zealand
    const { lat, lng } =
      window.Jbhifi.storeLocation === STORE_LOCATIONS.NZ
        ? STORE_LOCATIONS_COORDS[STORE_LOCATIONS.NZ]
        : STORE_LOCATIONS_COORDS[STORE_LOCATIONS.AU];
    const options = mapOptions({
      zoom: 4,
      center: new google.maps.LatLng(lat, lng),
    });
    map = new google.maps.Map($('#storefinder-map')[0], options);
    enableZoomControls(map);

    if (this.props.locations.length) {
      renderMarkers(this.props.locations);
    }
  }

  componentDidMount() {
    googleMapsInit(() => {
      this.setState(
        {
          googleLoaded: true,
        },
        this.loadMap
      );
    });
  }

  render() {
    return <div id="storefinder-map" style={{ height: '500px' }} />;
  }
}

storeMap.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape()),
};

export default storeMap;
